// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clsRemoveIcon {
  font-size: 20px;
  margin-top: 2px;
  cursor: pointer;
  color: red;
}

.toppingsCollapsedView {
  font-size: 12px;
  font-weight: lighter;
}`, "",{"version":3,"sources":["webpack://./src/app/components/short-cart/short-cart.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;AACF;;AACA;EACE,eAAA;EACA,oBAAA;AAEF","sourcesContent":[".clsRemoveIcon {\n  font-size: 20px;\n  margin-top: 2px;\n  cursor: pointer;\n  color: red;\n}\n.toppingsCollapsedView {\n  font-size: 12px;\n  font-weight: lighter;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
